import type { AccessEvaluator } from "../types";

/**
 * Bespoke evaluator for `users`. The backend special-cases this model by name
 * (not via a schema `access` constraint): for `Default` access the row filter
 * is `_id === userId` — a user sees *themselves*, not records they created
 * (`database.ts:1845-1850`). Routing `users` through the common evaluator
 * (which treats unconstrained `Default` as `creator === user`) would both
 * under-grant (hide a user's own profile when someone else created it) and
 * over-grant (expose teammates an admin provisioned).
 *
 * `users` records carry no enduser linkage, so the backend's `Assigned` path
 * matches nothing for them — `Assigned` always denies here.
 */
export const USERS_ACCESS_EVALUATOR: AccessEvaluator<"users"> = {
  evaluate: ({ record, currentUserId, accessType }) => {
    switch (accessType) {
      case "All":
        return true;
      case "Default":
        return record.id === currentUserId;
      default:
        return false;
    }
  },
};
